module.exports = __webpack_public_path__ + "static/media/worldwide.31f51ca4.svg";